import React, { useState } from 'react'
import { isEmpty } from 'lodash'

import { PlusCircle as PlusCircleIcon } from 'react-feather'
import {
  Container,
  Button,
  Box,
  Grid,
  TablePagination,
  Typography,
  useMediaQuery,
  Card,
} from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'

import { Page, ContentHeader, Permitted } from 'components'
import constants from 'constants/index'
import theme from 'theme'

import { ExternalPlatformIntegrationsTable, DialogForm } from './components'

import * as service from 'service'

import useFetch from 'hooks/useFetch'
import usePagination from 'hooks/usePagination'
import useAuth from 'hooks/useAuth'
import useStyles from './styles'

const { SEGCOOP_KIND, SMTP_KIND } = constants.externalPlatformIntegrations

const ExternalPlatformIntegrationsMain = () => {
  const [openDialogForm, setOpenDialogForm] = useState(false)
  const { company } = useAuth()

  const classes = useStyles()
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(10)

  const { response, isLoading, refresh } = useFetch(
    service.dponet.externalPlatformIntegrations.get,
    { perPage, page },
    [page, perPage],
  )

  const integrations = response?.data?.externalPlatformIntegrations || []
  const segcoopIntegrations = integrations.filter(
    (integration) => integration.externalPlatform === SEGCOOP_KIND,
  )
  const segcoopOptionDisabled = !isEmpty(segcoopIntegrations)
  const smtpIntegrations = integrations.filter(
    (integration) => integration.externalPlatform === SMTP_KIND,
  )
  const showSegcoopSection = !!company?.segcoopIntegration

  return (
    <Page title="Integrações com plataformas externas">
      <Container maxWidth={false} className={classes.container}>
        <ContentHeader title="Integrações">
          <Permitted
            tag={constants.permissions.EXTERNAL_PLATFORM_INTEGRATIONS.MANAGE}
          >
            <Button
              variant="contained"
              color="primary"
              startIcon={<PlusCircleIcon size={20} />}
              onClick={() => setOpenDialogForm(true)}
            >
              NOVA INTEGRAÇÃO
            </Button>
          </Permitted>
        </ContentHeader>

        {showSegcoopSection && (
          <Card>
            <Box p={2}>
              <Typography variant="h5">Segcoop</Typography>
            </Box>
            <Box display="flex" width="100%">
              <Grid container>
                <ExternalPlatformIntegrationsTable
                  integrations={response && segcoopIntegrations}
                  isLoading={isLoading}
                  onEvent={refresh}
                />
              </Grid>
            </Box>
          </Card>
        )}

        <Box mt={showSegcoopSection ? 2 : 0}>
          <Card>
            <Box p={2}>
              <Typography variant="h5">SMTP</Typography>
            </Box>
            <Box display="flex" width="100%">
              <Grid container>
                <ExternalPlatformIntegrationsTable
                  integrations={response && smtpIntegrations}
                  isLoading={isLoading}
                  onEvent={refresh}
                />
              </Grid>
            </Box>

            <Box px={2} display="flex" justifyContent="flex-end">
              {!isLoading && response ? (
                <TablePagination
                  component="div"
                  count={response?.data?.meta?.totalCount}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  page={page - 1}
                  rowsPerPage={perPage}
                  rowsPerPageOptions={[5, 10, 25, 100]}
                  labelRowsPerPage={isDesktop ? 'Por página' : ''}
                  nextIconButtonProps={{ size: 'small' }}
                  backIconButtonProps={{ size: 'small' }}
                />
              ) : (
                <Box py="11px">
                  <Skeleton variant="rect" width={200} height={30} />
                </Box>
              )}
            </Box>
          </Card>
        </Box>
      </Container>

      <DialogForm
        open={openDialogForm}
        setOpen={setOpenDialogForm}
        integration={null}
        onEvent={refresh}
        showSegcoopSection={showSegcoopSection}
        segcoopOptionDisabled={segcoopOptionDisabled}
      />
    </Page>
  )
}

export default ExternalPlatformIntegrationsMain
